export class Mese {
  id: number;
  label: string;
}
